/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState } from "react";
import CurrencyFormat from "react-currency-format";
import moment from "moment";
import "moment/locale/es";

const InfoTx = (props) => {
  const allowedChannels = ["albo.mirai", "stp.spei" , "banxico.spei"];
  const [allowHistory] = useState(allowedChannels.includes(props.data.channel));
  const hasAction = (action) => {
    return props.config?.actions?.indexOf(action) > -1;
  };

  const info = [
    { key: "uuid", label: "ID transacción" },
    { key: "tracking_key", label: "Clave de rastreo" },
    { key: "cdate", label: "Fecha en tránsito" },
    { key: "udate", label: "Fecha en firme" },
    { key: "currency", label: "Tipo de moneda" },
    { key: "previous_balance", label: "Saldo anterior a la operación" },
    { key: "new_balance", label: "Saldo posterior a la operación" },
    { key: "channelDesc", label: "Partner" },
    { key: "tipoTx", label: "Tipo de la transacción" },
    { key: "subtype", label: "Sub Tipo" },
    { key: "concept", label: "Nombre del comercio" },
    { key: "cardType", label: "Tarjeta virtual o física" },
    { key: "walletID", label: "Wallet ID" },
  ];

  const device_info = [
    { key: "source_ip", label: "IP Address" },
    { key: "geo", label: "Geolocalicazión" },
    { key: "di", label: "Device ID" },
  ];

  const remote_account = [
    { key: "bank_id", label: "Banco origen / destino", catalog: props.banks },
    { key: "clabe", label: "CLABE" },
    { key: "description_post_operation", label: "ID autorización" },
    { key: "authorization_number", label: "ID autorización" },
    { key: "email", label: "Email" },
    { key: "movement_id", label: "ID del movimiento" },
    { key: "movement_key", label: "Llave del movimiento" },
    { key: "name", label: "Nombre" },
    { key: "partner", label: "Partner" },
    { key: "reference", label: "Referencia" },
    { key: "type_reference", label: "Tipo de referencia" },
    { key: "capture_mode_desc", label: "Tipo de compra" },
    { key: "original_currency_code", label: "Origen de transacción" },
    { key: "transaction_id", label: "ID transacción" },
    { key: "uuid", label: "UUID Cuenta Cliente" },
  ];

  const contact_info = [
    { key: "name", label: "Nombre" },
    { key: "cdate", label: "Fecha de creación" },
    { key: "udate", label: "Fecha en actualización" },
  ];

  const tx_stream = [
    { key: "is_recurring", label: "Transacción recurrente" },
    { key: "offline_pin_validated", label: "PIN offline cifrado" },
    { key: "online_pin_present", label: "PIN online" },
    { key: "cvv_two_present", label: "CVV dinámico" },
    { key: "response_code", label: "Código de respuesta" },
    { key: "three_ds_sli", label: "SLI 3Ds" }
  ];

  return (
    <div data-testid="spaceListTxInfo" className="dataBlock">
      {props.data &&
        info.map((i, index) => {
          if(i.key === "cdate" || i.key === "udate"){
            var options: any = {timeZone: 'UTC', dateStyle:"long", timeStyle: "medium"};
            return (
              <div key={index} className="dataBlockItem">
                <label className="neutral report_display">{i.label}</label>
                <p>{(moment(new Date(props.data[i.key])).tz("America/Mexico_City").format('DD MMMM YYYY HH:mm:ss'))}</p>
              </div>
            );
          } else if((i.key === "previous_balance" || i.key === "new_balance") && props.data.hasOwnProperty(i.key) ){
            if(props.validateVip){
              return (
                <div key={index} className="dataBlockItem">
                  <label className="neutral report_display">{i.label}</label>
                  <CurrencyFormat
                    value={props.data[i.key].toString().indexOf(".") > -1 ? props.data[i.key] : `${props.data[i.key]}.00`}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalSeparator={"."}
                    prefix={"$"}
                    renderText={(value) => <p>{value}</p>}
                  />
                </div>
              );
            }
          } else if(i.key === "channelDesc" && props.data.hasOwnProperty(i.key)){
            return (
              <div key={index} className="dataBlockItem">
                <label className="neutral report_display">{i.label}</label>
                <p>{props.data[i.key] ? props.data[i.key] : "N/A"}</p>
              </div>
            )            
          } else {
            return (
              <div key={index} className="dataBlockItem">
                <label className="neutral report_display">{i.label}</label>
                <p>{props.data[i.key] ? props.data[i.key] : "N/A"}</p>
              </div>
            );
          }
        })}

      {/* -------------------------------------------------------------------- */}
      {props.data.remote_account && allowHistory && hasAction("history") &&
        <div>
          <hr /><p style={{padding: 0}}>Datos del dispositivo</p><br />
        </div>
      }
      {props.data.remote_account && allowHistory && hasAction("history") &&
        device_info.map((i, index) => {
          if (props.data.remote_account.hasOwnProperty(i.key) || (i.key === "geo" && props.data.remote_account.glat)) {
            return (
              <div key={index} className="dataBlockItem">
                <label className="neutral report_display">{i.label}</label>
                <p>{i.key === "geo" ? `${props.data.remote_account["glat"]}, ${props.data.remote_account["glon"]}` : props.data.remote_account[i.key] || "N/A"}</p>
              </div>
            );
          }
        })}

      {/* -------------------------------------------------------------------- */}
      {props.data.remote_account &&
        <div>
          <hr /><p style={{padding: 0}}>Información de cuenta remota</p><br />
        </div>
      }
      {props.data.remote_account &&
        remote_account.map((i, index) => {
          if (props.data.remote_account.hasOwnProperty(i.key)) {
            if (i.key === "uuid"){
              return allowHistory && hasAction("history") && (
                <div key={index} className="dataBlockItem">
                  <label className="neutral report_display">{i.label}</label>
                  <p>{props.data.remote_account[i.key] || "N/A"}</p>
                </div>
              );
            } else {
              return (
                <div key={index} className="dataBlockItem">
                  <label className="neutral report_display">{i.label}</label>
                  <p>{i.catalog ? props.data.remote_account["bank_name"] || i.catalog[props.data.remote_account[i.key]] || props.data.remote_account[i.key] : props.data.remote_account[i.key] ? props.data.remote_account[i.key] : "N/A"}</p>
                </div>
              );
            }
          }
        })}

      {/* -------------------------------------------------------------------- */}
      {props.data.remote_account && allowHistory && hasAction("history") &&
        <div>
          <hr /><p style={{padding: 0}}>Detalle del contacto destino</p><br />
        </div>
      }
      {props.data.remote_account && allowHistory && hasAction("history") &&
        contact_info.map((i, index) => {
          if (props.data.remote_account.hasOwnProperty(i.key)) {
            return (
              <div key={index} className="dataBlockItem">
                <label className="neutral report_display">{i.label}</label>
                <p>{props.data.remote_account[i.key] || "N/A"}</p>
              </div>
            );
          }
          if (props.data.hasOwnProperty(i.key)) {
            return (
              <div key={index} className="dataBlockItem">
                <label className="neutral report_display">{i.label}</label>
                <p>{props.data[i.key] || "N/A"}</p>
              </div>
            );
          }
        })}

      {/* -------------------------------------------------------------------- */}
      {props.data.remote_account && props.data.remote_account.hasOwnProperty('is_recurring') &&
        <div>
          <hr /><p style={{padding: 0}}>Transaction Stream</p><br />
          { tx_stream.map((i, index) => {
              var prop = props.data.remote_account
              if (prop.hasOwnProperty(i.key)) {
                return (
                  <div key={index} className="dataBlockItem">
                    <label className="neutral report_display">{i.label}</label>
                    <p>{prop.hasOwnProperty(i.key) ? 
                       String(prop[i.key]).charAt(0).toUpperCase() + String(prop[i.key]).slice(1)
                    : "N/A"}</p>
                  </div>
                );
              }
            })
          }
        </div>
      }   
    </div>
  );
};

export default InfoTx;